var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpaque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0797 4.70424L6.54975 9.40848L13.0797 14.1127L6.54975 18.817L0 14.0681L6.54481 9.36384L0 4.70424L6.54481 0L13.0797 4.70424ZM6.51018 20.2958L13.0401 15.5915L19.5701 20.2958L13.0401 25L6.51018 20.2958ZM13.0797 14.0681L19.6097 9.36384L13.0797 4.69866L19.5751 0L26.1199 4.70424L19.5751 9.40848L26.1199 14.1071L19.5751 18.8114L13.0797 14.0681Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpaque);
export default __webpack_public_path__ + "static/media/empaque.6952faff4ab3fe707f789cdb383af72b.svg";
export { ForwardRef as ReactComponent };